import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FlexLayoutModule, MediaMarshaller } from "@angular/flex-layout";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatChipsModule } from "@angular/material/chips";
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSliderModule } from "@angular/material/slider";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatStepperModule } from "@angular/material/stepper";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ContentHeaderComponent } from "./content-header/content-header.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { EmptyHeaderComponent } from "./empty-header/empty-header.component";
import { LoginHeaderComponent } from "./login-header/login-header.component";

import { DialogHeaderComponent } from "./dialog-header/dialog-header.component";
import { CustomerAddressComponent, CustomerHeaderInfoComponent } from "./customer-header-info";
import { MaterialElevationDirective, PhonePipe } from "./helpers";
import { PrimaryColorHeaderComponent } from "./primary-color-header/primary-color-header.component";
import { RccCurrencyInput } from "./rcc-currency/rcc-currency.component";
import { SummaryHeaderComponent } from './summary-header/summary-header.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule
  ],
  exports: [
    FlexLayoutModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatStepperModule,
    ContentHeaderComponent,
    LoginHeaderComponent,
    BreadcrumbComponent,
    EmptyHeaderComponent,
    DialogHeaderComponent,
    CustomerAddressComponent,
    CustomerHeaderInfoComponent,
    MaterialElevationDirective,
    PhonePipe,
    CurrencyPipe,
    PrimaryColorHeaderComponent,
    RccCurrencyInput,
    SummaryHeaderComponent
  ],
  declarations: [
    ContentHeaderComponent,
    LoginHeaderComponent,
    BreadcrumbComponent,
    EmptyHeaderComponent,
    DialogHeaderComponent,
    CustomerAddressComponent,
    CustomerHeaderInfoComponent,
    MaterialElevationDirective,
    PhonePipe,
    PrimaryColorHeaderComponent,
    RccCurrencyInput,
    SummaryHeaderComponent,
  ],
  providers: [CurrencyPipe]
})
export class SharedModule
{

  // all used to resolve issue in github stated below- printing breaking layout.
  lastValue;
  public constructor(
    m: MediaMarshaller,
  )
  {
    // hack until resolve: https://github.com/angular/flex-layout/issues/1201
    // @ts-ignore
    m.subject.subscribe((x) =>
    {
      // @ts-ignore
      if (m.activatedBreakpoints.filter((b) => b.alias === "print").length === 0)
      {
        // @ts-ignore
        this.lastValue = [...m.activatedBreakpoints];
      } 
      else
      {
        // @ts-ignore
        m.activatedBreakpoints = [...this.lastValue];
        // @ts-ignore
        m.hook.collectActivations = () => { };
        // @ts-ignore
        m.hook.deactivations = [...this.lastValue];
      }
    });
  }
}
